import React from "react";
import { useTable } from "../../Components/useTable";

const GifterRankingList = () => {
  const type = "Gifter Ranking";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "Code" },
    { id: "name", numeric: false, label: "Name" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "reward", numeric: false, label: "Reward" },
    { id: "totalDiamonds", numeric: false, label: "Total Diamond" },
    { id: "rank", numeric: false, label: "Rank" },
    { id: "type", numeric: false, label: "Type" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "updated", numeric: false, label: "Update At" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default GifterRankingList;
